import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { drugAPI } from '../services/api';

function DrugDetail() {
  const { applicationNumber } = useParams();
  const navigate = useNavigate();
  const [drug, setDrug] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDrugDetail = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await drugAPI.getByApplicationNumber(applicationNumber);
        if (response.data && response.data.results && response.data.results.length > 0) {
          setDrug(response.data.results[0]);
        } else {
          setError('Drug not found');
        }
      } catch (err) {
        setError(err.response?.data?.error || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDrugDetail();
  }, [applicationNumber]);

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading">Loading drug details...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <div style={{
          marginBottom: '1.5rem',
          paddingBottom: '1rem',
          borderBottom: '2px solid var(--light-bg)'
        }}>
          <button 
            onClick={() => navigate(-1)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.625rem 1.25rem',
              backgroundColor: 'white',
              color: 'var(--text-color)',
              border: '2px solid var(--border-color)',
              borderRadius: '8px',
              fontSize: '0.95rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = 'var(--primary-color)';
              e.currentTarget.style.color = 'var(--primary-color)';
              e.currentTarget.style.backgroundColor = 'var(--lighter-bg)';
              e.currentTarget.style.transform = 'translateX(-4px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = 'var(--border-color)';
              e.currentTarget.style.color = 'var(--text-color)';
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.transform = 'translateX(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
            }}
          >
            <span style={{ fontSize: '1.1rem' }}>←</span>
            <span>Back to Search</span>
          </button>
        </div>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  if (!drug) {
    return (
      <div className="page-container">
        <div style={{
          marginBottom: '1.5rem',
          paddingBottom: '1rem',
          borderBottom: '2px solid var(--light-bg)'
        }}>
          <button 
            onClick={() => navigate(-1)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.625rem 1.25rem',
              backgroundColor: 'white',
              color: 'var(--text-color)',
              border: '2px solid var(--border-color)',
              borderRadius: '8px',
              fontSize: '0.95rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = 'var(--primary-color)';
              e.currentTarget.style.color = 'var(--primary-color)';
              e.currentTarget.style.backgroundColor = 'var(--lighter-bg)';
              e.currentTarget.style.transform = 'translateX(-4px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = 'var(--border-color)';
              e.currentTarget.style.color = 'var(--text-color)';
              e.currentTarget.style.backgroundColor = 'white';
              e.currentTarget.style.transform = 'translateX(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
            }}
          >
            <span style={{ fontSize: '1.1rem' }}>←</span>
            <span>Back to Search</span>
          </button>
        </div>
        <p className="no-results">Drug not found</p>
      </div>
    );
  }

  const brandName = drug.openfda?.brand_name?.[0] || drug.products?.[0]?.brand_name || 'Unknown Drug';
  const genericName = drug.openfda?.generic_name?.[0] || 'N/A';
  const manufacturer = drug.openfda?.manufacturer_name?.[0] || drug.sponsor_name || 'N/A';
  
  // Extract numeric part from application number for FDA URL
  // Examples: "ANDA075794" -> "075794", "NDA021087" -> "021087"
  const getFdaApplNo = (appNum) => {
    if (!appNum) return '';
    // Remove letter prefix (ANDA, NDA, BLA, etc.) and keep only numbers
    const numericPart = appNum.replace(/^[A-Z]+/, '');
    return numericPart;
  };

  return (
    <div className="page-container">
      <div style={{
        marginBottom: '1.5rem',
        paddingBottom: '1rem',
        borderBottom: '2px solid var(--light-bg)'
      }}>
        <button 
          onClick={() => navigate(-1)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.625rem 1.25rem',
            backgroundColor: 'white',
            color: 'var(--text-color)',
            border: '2px solid var(--border-color)',
            borderRadius: '8px',
            fontSize: '0.95rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.borderColor = 'var(--primary-color)';
            e.currentTarget.style.color = 'var(--primary-color)';
            e.currentTarget.style.backgroundColor = 'var(--lighter-bg)';
            e.currentTarget.style.transform = 'translateX(-4px)';
            e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.borderColor = 'var(--border-color)';
            e.currentTarget.style.color = 'var(--text-color)';
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.transform = 'translateX(0)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
          }}
        >
          <span style={{ fontSize: '1.1rem' }}>←</span>
          <span>Back to Search</span>
        </button>
      </div>

      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '2rem',
        borderRadius: '16px',
        marginBottom: '2rem',
        boxShadow: '0 8px 32px rgba(102, 126, 234, 0.2)'
      }}>
        <h1 style={{
          color: 'white',
          fontSize: '2.25rem',
          fontWeight: '700',
          marginBottom: '1rem',
          textShadow: '0 2px 4px rgba(0,0,0,0.2)'
        }}>{brandName}</h1>
        <p style={{
          color: 'rgba(255,255,255,0.9)',
          fontSize: '1.1rem',
          marginBottom: '1rem',
          fontWeight: '500'
        }}>{genericName}</p>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <span style={{
            backgroundColor: 'rgba(255,255,255,0.25)',
            backdropFilter: 'blur(10px)',
            color: 'white',
            padding: '0.5rem 1rem',
            borderRadius: '20px',
            fontSize: '0.9rem',
            fontWeight: '600',
            border: '1px solid rgba(255,255,255,0.3)'
          }}>FDA Approved</span>
          {drug.products?.[0]?.marketing_status && (
            <span style={{
              backgroundColor: drug.products[0].marketing_status.includes('Prescription') ? 'rgba(243, 156, 18, 0.9)' : 'rgba(39, 174, 96, 0.9)',
              color: 'white',
              padding: '0.5rem 1rem',
              borderRadius: '20px',
              fontSize: '0.9rem',
              fontWeight: '600'
            }}>
              {drug.products[0].marketing_status}
            </span>
          )}
        </div>
      </div>

      <div style={{
        background: 'white',
        padding: '2rem',
        borderRadius: '12px',
        marginBottom: '1.5rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        border: '1px solid var(--light-bg)'
      }}>
        <h2 style={{
          color: 'var(--secondary-color)',
          fontSize: '1.5rem',
          marginBottom: '1.5rem',
          paddingBottom: '0.75rem',
          borderBottom: '3px solid var(--primary-color)',
          display: 'inline-block'
        }}>Basic Information</h2>
        <div className="info-grid">
          <div className="info-item">
            <strong>Generic Name:</strong>
            <span>{genericName}</span>
          </div>
          <div className="info-item">
            <strong>Manufacturer:</strong>
            <span>{manufacturer}</span>
          </div>
          <div className="info-item">
            <strong>Sponsor:</strong>
            <span>{drug.sponsor_name || 'N/A'}</span>
          </div>
          <div className="info-item">
            <strong>Application Number:</strong>
            <span>{drug.application_number || 'N/A'}</span>
          </div>
          {drug.openfda?.product_type && (
            <div className="info-item">
              <strong>Product Type:</strong>
              <span>{drug.openfda.product_type.join(', ')}</span>
            </div>
          )}
          {drug.openfda?.application_type && (
            <div className="info-item">
              <strong>Application Type:</strong>
              <span>{drug.openfda.application_type.join(', ')}</span>
            </div>
          )}
        </div>
      </div>

      {drug.products && drug.products.length > 0 && (
        <div style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '12px',
          marginBottom: '1.5rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '1px solid var(--light-bg)'
        }}>
          <h2 style={{
            color: 'var(--secondary-color)',
            fontSize: '1.5rem',
            marginBottom: '1.5rem',
            paddingBottom: '0.75rem',
            borderBottom: '3px solid var(--primary-color)',
            display: 'inline-block'
          }}>Product Details</h2>
          {drug.products.map((product, index) => (
            <div key={index} className="subsection" style={{ marginBottom: '1.5rem', padding: '1rem', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
              <h3 style={{ fontSize: '1.1rem', marginTop: 0, color: '#2c3e50' }}>
                {product.brand_name || `Product ${index + 1}`}
              </h3>
              <div className="info-grid">
                <div className="info-item">
                  <strong>Dosage Form:</strong>
                  <span>{product.dosage_form || 'N/A'}</span>
                </div>
                <div className="info-item">
                  <strong>Route:</strong>
                  <span>{product.route || 'N/A'}</span>
                </div>
                <div className="info-item">
                  <strong>Marketing Status:</strong>
                  <span>{product.marketing_status || 'N/A'}</span>
                </div>
                {product.product_number && (
                  <div className="info-item">
                    <strong>Product Number:</strong>
                    <span>{product.product_number}</span>
                  </div>
                )}
              </div>
              
              {product.active_ingredients && product.active_ingredients.length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                  <strong>Active Ingredients:</strong>
                  <ul style={{ margin: '0.5rem 0', paddingLeft: '1.5rem' }}>
                    {product.active_ingredients.map((ing, i) => (
                      <li key={i}>
                        <strong>{ing.name}</strong> - {ing.strength}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {drug.openfda?.substance_name && drug.openfda.substance_name.length > 0 && (
        <div style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '12px',
          marginBottom: '1.5rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '1px solid var(--light-bg)'
        }}>
          <h2 style={{
            color: 'var(--secondary-color)',
            fontSize: '1.5rem',
            marginBottom: '1.5rem',
            paddingBottom: '0.75rem',
            borderBottom: '3px solid var(--primary-color)',
            display: 'inline-block'
          }}>Active Substances</h2>
          <div className="tag-list">
            {drug.openfda.substance_name.map((substance, index) => (
              <span key={index} className="tag">{substance}</span>
            ))}
          </div>
        </div>
      )}

      {drug.openfda?.pharm_class_epc && drug.openfda.pharm_class_epc.length > 0 && (
        <div style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '12px',
          marginBottom: '1.5rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '1px solid var(--light-bg)'
        }}>
          <h2 style={{
            color: 'var(--secondary-color)',
            fontSize: '1.5rem',
            marginBottom: '1.5rem',
            paddingBottom: '0.75rem',
            borderBottom: '3px solid var(--primary-color)',
            display: 'inline-block'
          }}>Pharmacologic Class (EPC)</h2>
          <div className="tag-list">
            {drug.openfda.pharm_class_epc.map((pharmClass, index) => (
              <span key={index} className="tag tag-info">{pharmClass}</span>
            ))}
          </div>
        </div>
      )}

      {drug.openfda?.pharm_class_moa && drug.openfda.pharm_class_moa.length > 0 && (
        <div style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '12px',
          marginBottom: '1.5rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '1px solid var(--light-bg)'
        }}>
          <h2 style={{
            color: 'var(--secondary-color)',
            fontSize: '1.5rem',
            marginBottom: '1.5rem',
            paddingBottom: '0.75rem',
            borderBottom: '3px solid var(--primary-color)',
            display: 'inline-block'
          }}>Mechanism of Action</h2>
          <div className="tag-list">
            {drug.openfda.pharm_class_moa.map((moa, index) => (
              <span key={index} className="tag tag-success">{moa}</span>
            ))}
          </div>
        </div>
      )}

      {drug.submissions && drug.submissions.length > 0 && (
        <div style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '12px',
          marginBottom: '1.5rem',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '1px solid var(--light-bg)'
        }}>
          <h2 style={{
            color: 'var(--secondary-color)',
            fontSize: '1.5rem',
            marginBottom: '1.5rem',
            paddingBottom: '0.75rem',
            borderBottom: '3px solid var(--primary-color)',
            display: 'inline-block'
          }}>Submission History</h2>
          <div className="timeline">
            {drug.submissions.slice(0, 10).map((submission, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <strong>{submission.submission_type || 'Submission'}</strong>
                      <div style={{ color: '#7f8c8d', fontSize: '0.9em', marginTop: '0.25rem' }}>
                        {submission.submission_number && `Submission #${submission.submission_number}`}
                      </div>
                    </div>
                    {submission.submission_status && (
                      <span className={`badge ${submission.submission_status.includes('AP') ? 'badge-success' : 'badge-warning'}`}>
                        {submission.submission_status}
                      </span>
                    )}
                  </div>
                  {submission.submission_status_date && (
                    <div style={{ marginTop: '0.5rem', color: '#7f8c8d', fontSize: '0.9em' }}>
                      <strong>Date:</strong> {submission.submission_status_date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')}
                    </div>
                  )}
                  {submission.review_priority && (
                    <div style={{ marginTop: '0.25rem', color: '#7f8c8d', fontSize: '0.9em' }}>
                      <strong>Priority:</strong> {submission.review_priority}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          {drug.submissions.length > 10 && (
            <p style={{ color: '#7f8c8d', fontSize: '0.9em', marginTop: '1rem' }}>
              Showing 10 of {drug.submissions.length} submissions
            </p>
          )}
        </div>
      )}

      <div style={{
        background: 'white',
        padding: '2rem',
        borderRadius: '12px',
        marginBottom: '1.5rem',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        border: '1px solid var(--light-bg)'
      }}>
        <h2 style={{
          color: 'var(--secondary-color)',
          fontSize: '1.5rem',
          marginBottom: '1.5rem',
          paddingBottom: '0.75rem',
          borderBottom: '3px solid var(--primary-color)',
          display: 'inline-block'
        }}>Source Information</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div style={{ 
            padding: '1rem', 
            backgroundColor: '#e8f4f8', 
            borderRadius: '8px',
            borderLeft: '4px solid #3498db'
          }}>
            <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', color: '#2c3e50' }}>
              🔗 FDA Drugs@FDA Database
            </h3>
            <p style={{ margin: '0 0 0.75rem 0', color: '#7f8c8d', fontSize: '0.9em' }}>
              This information is sourced from the FDA's official Drugs@FDA database, which provides comprehensive details about FDA-approved drug products.
            </p>
            <a 
              href={`https://www.accessdata.fda.gov/scripts/cder/daf/index.cfm?event=overview.process&ApplNo=${getFdaApplNo(drug.application_number)}`}
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.875rem 1.75rem',
                background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '10px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(52, 152, 219, 0.3)',
                border: 'none'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(52, 152, 219, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(52, 152, 219, 0.3)';
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                <polyline points="15 3 21 3 21 9"/>
                <line x1="10" y1="14" x2="21" y2="3"/>
              </svg>
              <span>View on FDA Website</span>
            </a>
          </div>

          <div style={{ 
            padding: '1rem', 
            backgroundColor: '#fff9e6', 
            borderRadius: '8px',
            borderLeft: '4px solid #f39c12'
          }}>
            <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', color: '#2c3e50' }}>
              ⚠️ Important Notice
            </h3>
            <p style={{ margin: 0, color: '#7f8c8d', fontSize: '0.9em' }}>
              This information is for educational and research purposes only. Do not rely on this information to make decisions regarding medical care. Always consult with a healthcare professional.
            </p>
          </div>
        </div>
      </div>

      <div style={{ 
        marginTop: '2rem', 
        display: 'flex', 
        gap: '1rem', 
        flexWrap: 'wrap',
        paddingTop: '2rem',
        borderTop: '2px solid var(--light-bg)'
      }}>
        <button 
          onClick={() => navigate(-1)} 
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: 'white',
            color: 'var(--primary-color)',
            border: '2px solid var(--primary-color)',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '0.95rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--primary-color)';
            e.currentTarget.style.color = 'white';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(46, 134, 222, 0.3)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.color = 'var(--primary-color)';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <span>←</span>
          <span>Back to Search</span>
        </button>
        <Link 
          to="/drugs" 
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: 'var(--primary-color)',
            color: 'white',
            border: '2px solid var(--primary-color)',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '0.95rem',
            textDecoration: 'none',
            transition: 'all 0.3s ease',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--primary-dark)';
            e.currentTarget.style.borderColor = 'var(--primary-dark)';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(46, 134, 222, 0.3)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--primary-color)';
            e.currentTarget.style.borderColor = 'var(--primary-color)';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          <span>🔍</span>
          <span>New Search</span>
        </Link>
      </div>
    </div>
  );
}

export default DrugDetail;
